import {useNavigate} from 'react-router';

import {getBadgeDetailsContent} from '@/services/content/appContent';
import type {Badge, JourneyLevelBadge} from '@/types/loyalty';
import SingleLevelBadgeDetails from '@/views/SingleLevelBadgeDetails/SingleLevelBadgeDetails';

type JourneyLevelBadgeDetailsProps = {
    journeyBadge: Badge;
    levelBadgeId: string;
};

const levelToBadge = (level: JourneyLevelBadge): Badge => ({
    id: level.badgeId,
    title: level.displayName,
    description: level.badgeDescription,
    status: level.status,
    imageUrl: level.imageUrl,
    actions: level.actions,
    totalSteps: level.totalSteps,
    finishedSteps: level.finishedSteps,
    rewards: level.rewards,
    isSingleLevel: true,
});

const JourneyLevelBadgeDetails = ({journeyBadge, levelBadgeId}: JourneyLevelBadgeDetailsProps) => {
    const navigate = useNavigate();
    const level = journeyBadge.journeyLevels?.find((l) => l.badgeId === levelBadgeId);

    const {multiLevelBadgeDetailsContent} = getBadgeDetailsContent();
    const {selectRewardPluralForms} = multiLevelBadgeDetailsContent ?? {};

    if (!level) return null;

    return (
        <SingleLevelBadgeDetails
            badge={levelToBadge(level)}
            showProgress
            hideOtherBadges
            onBack={() => navigate(-1)}
            selectRewardPluralForms={selectRewardPluralForms}
        />
    );
};

export default JourneyLevelBadgeDetails;
